module.exports = __webpack_public_path__ + "img/collectionFrequencySuc.79372a3f.png";